<template>
    <el-dialog title="详情" width="640px" :model-value="modelValue" @close="closed" :close-on-click-modal="false">
        <el-form ref="formRef" v-loading="!formData.user_name" :model="formData" label-width="120px" style="max-width: 540px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="用户名称" prop="user_number">
                        <span>{{ formData.user_number }}</span>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="姓名" prop="user_name">
                        <span>{{ formData.user_name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="所属部门" prop="dept_name">
                        <span>{{ formData.dept_name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="手机号码" prop="telephone">
                        <span>{{ formData.telephone }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formData.email">
                    <el-form-item label="邮箱" prop="email">
                        <span>{{ formData.email }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="是否导入">
                        <span :style="{ color: formData.is_import ? '#67c23a' : '#f56c6c' }">
                            {{ formData.is_import ? '已导入' : '未导入' }}
                        </span>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">关闭</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { getSyncUserDetail } from '@/api/sync-users.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    user_id: {
        type: String,
        required: true
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

const formRef = ref(null)
const formData = ref({
    email: '',
    telephone: '',
    user_number: '',
    dept_name: '',
    user_name: '',
    is_import: ''
})

const closed = () => {
    emits('update:modelValue', false)
}

// 获取导入用户详情
const doGetOperationDetail = async () => {
    const data = await getSyncUserDetail(props.user_id)
    formData.value = data
}

// 请求用户详情
watch(
    () => props.user_id,
    (newVal) => {
        if (newVal) {
            doGetOperationDetail()
        } else {
            // 置空
            formData.value = {
                email: '',
                telephone: '',
                user_number: '',
                dept_name: '',
                user_name: '',
                is_import: ''
            }
        }
    }
)
</script>

<style scoped></style>
